import atividadesV4 from '../data/atividades-v4.js';
import { EIXOS, SKILLS } from './skills.js';
import { normalizarHabilidadesLista } from '../lib/skillAliases.js';

function materialToText(material) {
  if (typeof material === 'string') return material;
  return [material?.item, material?.alternativa ? `(alternativa: ${material.alternativa})` : ''].filter(Boolean).join(' ');
}

function fonteToText(fonte) {
  if (!fonte) return '';
  if (typeof fonte === 'string') return fonte;
  return [fonte.titulo, fonte.autoria, fonte.url].filter(Boolean).join(' — ');
}

export function normalizeActivity(activity = {}) {
  const habilidades = normalizarHabilidadesLista(activity.habilidades_alvo || activity.habilidades || activity.habilidade);
  const objetivo = activity.objetivo || activity.objetivo_operacional || '';
  const roteiro = Array.isArray(activity.roteiro)
    ? activity.roteiro
    : (activity.passo_a_passo || []).map((acao, index) => ({ passo: index + 1, acao }));

  return {
    ...activity,
    versaoSchema: activity.versaoSchema || 4,
    habilidades_alvo: habilidades,
    objetivo,
    objetivo_operacional: activity.objetivo_operacional || objetivo,
    materiais: (activity.materiais || []).map(materialToText),
    materiaisDetalhados: activity.materiais || [],
    roteiro,
    passo_a_passo: roteiro.map((item) => item.acao || String(item)),
    necessidades_indicadas: activity.necessidades_indicadas || activity.necessidades || [],
    funcoes: activity.funcoes || habilidades,
    adaptacoes: activity.adaptacoes || { orientacao: Object.values(activity.adaptacoes_por_perfil || {}).join(' ') },
    como_medir_progresso: activity.como_medir_progresso || activity.registro?.como || '',
    fonte: fonteToText(activity.fonte),
    fonteDetalhada: activity.fonte,
  };
}

export function getActivities(data = {}) {
  return [...atividadesV4, ...(data.customActivities || [])].map(normalizeActivity);
}

export function findActivity(id, data = {}) {
  return getActivities(data).find((activity) => activity.id === id) || null;
}

export function getActivityBank(data = {}) {
  return {
    versao: '4.0.0',
    eixos: EIXOS.map((eixo) => ({ ...eixo, habilidades: SKILLS.filter((skill) => skill.eixo === eixo.id) })),
    atividades: getActivities(data),
  };
}

export function getActivityTaxonomy(bank = getActivityBank()) {
  const atividades = bank.atividades || [];
  return {
    eixos: bank.eixos || [],
    habilidades: (bank.eixos || []).flatMap((eixo) => eixo.habilidades || []),
    necessidades: [...new Set(atividades.flatMap((atividade) => atividade.necessidades_indicadas || []))].sort((a, b) => a.localeCompare(b, 'pt-BR')),
    funcoes: [...new Set(atividades.flatMap((atividade) => atividade.funcoes || []))].sort((a, b) => a.localeCompare(b, 'pt-BR')),
    dificuldades: [...new Set(atividades.map((atividade) => atividade.nivel_dificuldade).filter(Boolean))].sort((a, b) => a - b),
  };
}
